import React, {useCallback, useEffect, useState} from 'react';
import TimezoneSource, {Timezone} from 'sources/admin/TimezoneSource';
import SingleAutocomplete from '@components/auto-complete/SingleAutocomplete';

interface TimezoneAutocompleteProps {
  value: string;
  setUserZone: (tz: string) => void;
  error?: boolean;
  className?: string;
}

export const TimezoneAutocomplete: React.FC<TimezoneAutocompleteProps> = ({
  value: userZone,
  setUserZone,
  error = false,
  className = '',
}) => {
  const [value, setValue] = useState<Timezone>();

  useEffect(() => {
    if (userZone) {
      TimezoneSource.fetchNamed(userZone).then(setValue);
    }
  }, [userZone]);

  const callback = useCallback(
    (tz: Timezone) => {
      setValue(tz);
      setUserZone(tz?.name);
    },
    [setUserZone]
  );
  // if we had a zone come in, but we haven't loaded it yet from the server
  if (userZone && !value) return null;

  return (
    // the form bit is necessary to make chrome autocomplete go away
    <form>
      <SingleAutocomplete
        className={className ?? ''}
        fullSource={TimezoneSource.fetchTimezones}
        commonSource={TimezoneSource.fetchCommon}
        value={value}
        setValue={callback}
        placeholder={'Search by nearby city or timezone code'}
        previewLabel={() =>
          `Showing common timezone selections. Type to search for a specific zone abbreviation or nearby city`
        }
        error={error}
      />
    </form>
  );
};
